import { BindingCreator } from '@dreryk/react-common';
import { Multiselect } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

import {
   useVisitEncounterModeFilterSearchParamHandler,
   useVisitEncounterModeTriggerLabelExtractor,
} from './VisitEncounterModeField.hooks';
import { StyledVisitEncounterModeField } from './VisitEncounterModeField.styled';
import { VisitEncounterMode } from './VisitEncounterModeField.types';
import { VISIT_ENCOUNTER_MODE_ID_MAP } from './VisitEncounterModeField.constants';

type VisitEncounterModeFieldFormBeanPart = { visitEncounterModes: VisitEncounterMode[] };

type VisitEncounterModeFieldProps = {
   register: BindingCreator<VisitEncounterModeFieldFormBeanPart, 'visitEncounterModes'>;
   currentFilter: VisitEncounterMode[];
};

const items = Object.keys(VISIT_ENCOUNTER_MODE_ID_MAP) as VisitEncounterMode[];

export const VisitEncounterModeField = (props: VisitEncounterModeFieldProps): JSX.Element => {
   return (
      <StyledVisitEncounterModeField>
         <Multiselect<VisitEncounterMode>
            testId={'visitEncounterModes'}
            triggerLabelExtractor={useVisitEncounterModeTriggerLabelExtractor()}
            placeholder={appointmentsTranslationKeys.visitEncounterModeFilter.selectEncounterModes}
            controller={props.register('visitEncounterModes')}
            onHide={useVisitEncounterModeFilterSearchParamHandler(props.currentFilter)}
         >
            <>
               <Multiselect.SelectAll<VisitEncounterMode>
                  testId={'selectAllEncounterModes'}
                  items={items}
                  selectAllLabel={appointmentsTranslationKeys.visitEncounterModeFilter.selectAll}
               />
               <Multiselect.List items={items}>
                  {(item) => (
                     <Multiselect.Item
                        item={item}
                        testId={item}
                        label={appointmentsTranslationKeys.visitEncounterModeMap[item]}
                     />
                  )}
               </Multiselect.List>
            </>
         </Multiselect>
      </StyledVisitEncounterModeField>
   );
};
